<template>
  <div class="login-container">
    <div class="login-wrapper">
      <!-- 左侧展示区 -->
      <div class="login-left">
        <!-- 顶部横幅 -->
        <div class="top-banner">
          <div class="banner-content">
            <img src="@/assets/logo-xmyk.png" alt="系统Logo" class="banner-logo" />
            <h1 class="banner-title">数字化信息工作平台</h1>
          </div>
        </div>
        <div class="login-image">
          <img src="@/assets/login-logo-2.jpg" alt="系统展示图" />
        </div>
      </div>

      <!-- 右侧登录区 -->
      <div class="login-right">
        <el-card class="login-box">
          <h2>用户登录</h2>
          <el-form :model="loginForm" label-width="60px">
            <el-form-item label="手机号">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入手机号"
                @keyup.enter="handleLogin"
              >
                <template #prefix>
                  <el-icon><User /></el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="请输入密码"
                @keyup.enter="handleLogin"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label-width="0px">
              <el-button
                type="primary"
                @click="handleLogin"
                :loading="loading"
                class="login-button"
                >登录</el-button
              >
            </el-form-item>
            <el-form-item label-width="0px" class="forgot-password-item">
              <div class="login-actions">
                <el-button link @click="goToResetPassword" class="forgot-password">
                  忘记密码？
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/sso/login";
import { User, Lock } from "@element-plus/icons-vue";

export default {
  name: "LoginPage",
  components: {
    User,
    Lock,
  },
  created() {
    // 如果已登录，直接跳转到overview
    if (localStorage.getItem("userInfo")) {
      this.$router.push("/main/data-tasks/overview");
    }
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loading: false,
    };
  },
  methods: {
    async handleLogin() {
      if (!this.loginForm.username || !this.loginForm.password) {
        this.$message.error("请输入用户名和密码");
        return;
      }

      this.loading = true;
      try {
        const response = await login(this.loginForm);
        console.log("登录结果:", response);
        if (response.errcode === 0) {
          // 服务器会通过Set-Cookie自动设置cookie，前端无需额外处理
          // 存储用户信息到本地
          localStorage.setItem("userInfo", JSON.stringify(response.data));
          this.$router.push("/main/data-tasks/overview");
          this.$message.success(response.errmsg);
        } else if (response.errcode === 1001) {
          // 进入重设密码流程，传递重置token和用户ID
          this.$router.push("/login/inituser");
          return;
        } else {
          this.$message.error(response.data.message || "登录失败");
        }
      } catch (error) {
        if (error.data && error.data.errcode === 1001) {
          // 进入重设密码流程，传递重置token和用户ID
          this.$router.push("/login/inituser");
          return;
        }
        console.error("登录错误:", error);
      } finally {
        this.loading = false;
      }
    },
    goToResetPassword() {
      this.$router.push('/reset-password');
    },
  },
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-wrapper {
  display: flex;
  width: 100%;
  max-width: 1200px;
  min-height: 500px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.login-left {
  flex: 1;
  background-color: #fff;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.top-banner {
  background: linear-gradient(135deg, #1e90ff, #70a1ff);
  padding: 12px 30px;
  color: #fff;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.banner-logo {
  height: 40px;
  width: auto;
}

.banner-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.login-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login-image img {
  max-width: 90%;
  height: auto;
  max-height: 350px;
  border-radius: 4px;
}

.login-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 30px;
  background-color: #fff;
  border-left: 1px solid #eee;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 15px;
  box-shadow: none;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #303133;
}

.login-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

.login-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

/* 确保忘记密码按钮所在的表单项内容右对齐 */
.forgot-password-item :deep(.el-form-item__content) {
  display: flex;
  justify-content: flex-end;
}

.forgot-password {
  color: #409eff;
  font-size: 14px;
}

.forgot-password:hover {
  color: #66b1ff;
}

:deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px #dcdfe6 inset;
}

:deep(.el-input__wrapper:hover) {
  box-shadow: 0 0 0 1px #c0c4cc inset;
}

:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #409eff inset;
}

:deep(.el-icon) {
  font-size: 16px;
  color: #909399;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
    margin: 20px;
    min-height: 0;
  }

  .login-left {
    padding: 0;
  }

  .top-banner {
    padding: 10px 20px;
  }

  .banner-title {
    font-size: 20px;
  }

  .login-image {
    padding: 20px;
  }

  .login-image img {
    max-height: 200px;
  }

  .login-right {
    padding: 20px;
    border-left: none;
    border-top: 1px solid #eee;
  }
}

@media (max-width: 480px) {
  .banner-content {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .banner-logo {
    height: 30px;
  }

  .login-wrapper {
    margin: 10px;
  }

  .login-image {
    padding: 15px;
  }

  .login-right {
    padding: 15px;
  }
}
</style>
